import React from "react";
import { Footer as FooterShell } from "@sscs/ui";
import styles from "./footer.module.scss";
import FooterLinks from "./FooterLinks";
import FooterReleaseInfo from "./FooterReleaseInfo";

const Footer = (): React.JSX.Element => (
  <FooterShell
    className={styles.container}
    left={<FooterReleaseInfo />}
    right={<FooterLinks />}
  />
);

export default Footer;
